import React from "react"
import { ConfirmEmail as ConfirmEmailContainer } from "../../features/account"

const ConfirmEmail = () => <ConfirmEmailContainer redirectTo="/" />

export default ConfirmEmail
